(() => {
  let inFlight = false;
  let queued = false;
  let lastValue = null;

  async function computeHasSubscription() {
    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
    return cart.items.some(i => !!i.selling_plan_allocation);
  }

  async function writeFlag(hasSub) {
    // Avoid spamming /cart/update.js if unchanged
    if (lastValue === hasSub) return;
    lastValue = hasSub;

    await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { has_subscription: hasSub ? 'true' : 'false' }
      })
    });
  }

  async function syncFlag() {
    if (inFlight) { queued = true; return; }
    inFlight = true;
    try {
      const hasSub = await computeHasSubscription();
      await writeFlag(hasSub);
    } catch (e) {
      // Don't break cart UX if this fails
      console.warn('[checkout-flags] sync failed', e);
    } finally {
      inFlight = false;
      if (queued) { queued = false; syncFlag(); }
    }
  }

  // Run once on page load
  document.addEventListener('DOMContentLoaded', () => syncFlag());

  // Catch AJAX cart changes
  const origFetch = window.fetch;
  window.fetch = async function(resource, init) {
    const res = await origFetch.apply(this, arguments);
    try {
      const url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        // After the cart call completes, recompute the flag
        syncFlag();
      }
    } catch (_) {}
    return res;
  };
})();
